import {makeAutoObservable, runInAction} from "mobx"
import {
  getCaptainInfo,
  TCaptainInfo,
  TCaptainData,
  TBoatInfo,
  updateCaptainData,
  updateBoatInfo
} from "@ui/api/user"
import store from "../"

export interface IProfile {
  readonly info: TCaptainInfo
  readonly hasBoatInfo: boolean

  init(): void
  updateCaptain(data: TCaptainData): Promise<void>
  updateBoat(info: TBoatInfo): Promise<void>
}

export class Profile implements IProfile {
  info: TCaptainInfo = {}

  constructor() {
    makeAutoObservable(this)
  }

  get hasBoatInfo() {
    return !!this.info.boat && !Object.entries(this.info.boat).every(([key, val]) => key.includes("_unit") || !val)
  }

  init = () => {
    const {debug} = store
    getCaptainInfo()
      .then(info => runInAction(() => this.info = info))
      .catch(error => debug.error(`Dictionary::getCaptainInfo::error: ${error.code}, ${error.message}`))
  }

  updateCaptain = async (data: TCaptainData) => {
    await updateCaptainData(data)
      .then(() =>
        runInAction(() =>
          this.info = {...this.info, ...data}))
  }

  updateBoat = async (info: TBoatInfo) => {
    const boatInfo = {...this.info.boat, ...info}
    await updateBoatInfo(boatInfo)
      .then(() =>
        runInAction(() =>
          this.info = {...this.info, boat: boatInfo}))
  }
}
